<div class="verifiication-container">
  <email-verification-message [email]="email"></email-verification-message>
</div>